import React from 'react'

export default function Farming() {
  return (
    <>
      <section className='jimfarming-area'>
        <div className='container'>
          <div className='row '>
            <div className='col-lg-6 col-md-6 wow animate__animated animate__fadeInUp'>
              <p>Organic Farming & Fresh Harvest Living Sustainable Practices & Farm-to-Table Experiences Natural Growth & Green Landscapes Pure Living at De Coracao</p>
            </div>
          </div>
        </div>
          <img src='/image/jimcorbett-farming.webp' className='img-responsive' alt='farming' />
      </section>
    </>
  )
}
